(function referenceToolbarActions(global) {
  "use strict";

  /**
 * Состояние кнопки "Область группироки".
 * @since 5.0.0.4209
 * @function Core.toolBars.reference.selectFilterButton
 */
  global.selectFilterButton = function (toolItem) {
    $(function () {
      if (Core.grid.reference && Core.grid.reference.state) {
        var selected = Core.grid.reference.state.IsFilterPanelVisible;
        if (selected) toolItem.select();
      }
    });
    return global;
  };

  global.toggleFilterPanel = function (el) {
    var jButton = $(el);
    if (jButton.hasClass("disabled")) return;

    var isEnabled = jButton.hasClass("selected");
    if (isEnabled) {
      jButton.removeClass("selected");
    } else {
      jButton.addClass("selected");
    };

    Core.grid.reference.toggleFiltering(!isEnabled);
  };

  global.selectUseArchiveDataButton = function (toolItem) {
    var RefName = WA.CR.getReferenceCode();
    var RefView = WA.CR.getReferenceView();
    WA.SRV.call("/Reference.asmx/GetArchiveDataShowing", { ReferenceName: RefName, ReferenceView: RefView }).done(function (enabled) {
      if (enabled) toolItem.select();
    });
    return global;
  };

  global.toggleUseArchiveDataPanel = function (btn) {
    var isEnabled = $(btn).hasClass('selected');
    if (!isEnabled) {
      WA.CR.toolBar.buttons[btn.getAttribute('name')].select();
    } else {
      WA.CR.toolBar.buttons[btn.getAttribute('name')].unSelect();
    }
    var RefName = WA.CR.getReferenceCode();
    var RefView = WA.CR.getReferenceView();
    WA.SRV.call("/Reference.asmx/SetArchiveDataShowing", { Enabled: !isEnabled, ReferenceName: RefName, ReferenceView: RefView })
    Core.grid.reference.reloadData()
  };

  /**
 * Состояние кнопки "Область группироки".
 * @since 5.0.0.4209
 * @function Core.toolBars.reference.enableDeleteRecordBtn
 */
  global.selectGroupButton = function (toolItem) {
    $(function () {
      if (Core.grid.reference && Core.grid.reference.state) {
        var selected = Core.grid.reference.state.IsGroupPanelVisible;
        if (selected) toolItem.select();
      }
    });
    return global;
  };

  global.toggleGroupPanel = function (el) {
    var jButton = $(el);
    if (jButton.hasClass("disabled")) return;

    var isEnabled = jButton.hasClass("selected");
    if (isEnabled) {
      jButton.removeClass("selected");
    } else {
      jButton.addClass("selected");
    };

    Core.grid.reference.toogleGrouping(!isEnabled);
  };

  global.autoAdjustColumnWidth = function (el) {
    var jButton = $(el);
    if (jButton.hasClass("disabled")) return;

    var isEnabled = jButton.hasClass("selected");
    if (isEnabled) {
      jButton.removeClass("selected");
    } else {
      jButton.addClass("selected");
    };

    Core.grid.reference.autoAdjustColumnWidth(!isEnabled);
  };

  /**
  * Окно выбора отображаемых колонок
  */
  global.selectVisibleColumns = function () {
    var columns = Core.grid.reference.getColumnsForDialog();

    var visibleColumns = Core.grid.reference.getVisibleColumnsForDialog();
    //var visibleColumnsIds = _(visibleColumns).pluck('id');

    var dialog = new WebAccess.components.dialogs.SelectableMultiSelect(columns, visibleColumns).bind("selectComplete", function (newVisibleColumns) {
      //  var removedColumns = _.difference(visibleColumnsIds, _(newVisibleColumns).pluck('id'));
      //      Core.grid.reference.unGroupColumnsById(removedColumns);

      Core.grid.reference.setVisibleColumnsFromDialog(newVisibleColumns);
    });

    dialog.title = L("GRID_VISIBLE_COLUMNS");
    dialog.filterPlaceholder = L("GRID_SEARCH_IN_COLUMNS");
    dialog.availableItemslabel = L("GRID_ALL_COLUMNS");
    dialog.selectedItemslabel = L("GRID_SELECTED_COLUMNS");
    dialog.isShowCancelButton = true;
    dialog.show();

    BindHelpIcoClickOnModalWindow('VisibleColumns');

    /*    } else {
          ShowError(L('ERR_UNEXPECTED_ERROR'));
        }*/
  };
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
   * Доступность кнопки "Удалить запись справочника".
   * @since 5.0.0.4209
   * @function Core.toolBars.reference.enableDeleteRecordBtn
   */
  global.enableDeleteRecordBtn = function (toolItem) {
    var hasRights = ($('#HasUserRightsForDeleteRefRec').val() === 'True');
    if (hasRights) {
      Core.toolBars.main.enableButtonOnItemsSelectGt(toolItem, 0);
    } else {
      toolItem.disable();
    }
    return global;
  };
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
* Доступность кнопки "Копировать запись справочника".
* @since 5.4.1.1002
* @function Core.toolBars.reference.enableCopyRecordBtn
*/
  global.enableCopyRecordBtn = function (toolItem) {
    var hasRights = ($('#HasUserRightsForCopyRefRec').val() === 'True');
    if (hasRights) {
      Core.toolBars.main.enableButtonOnItemsSelectGt(toolItem, 0);
    } else {
      toolItem.disable();
    }
    return global;
  };
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
   * Выполняет действие "Удалить запись справочника".
   * @since 5.0.0.4200
   * @function Core.toolBars.reference.DeleteRecord
   */
  global.DeleteRecord = function () {
    if (WA.getLocation() === "referencerecords") {
      DeleteSelectedRecords();
    }
  };
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
   * Навешивает контекстное меню текущего фильтра.
   * @since 5.0.0.4200
   * @function Core.toolBars.reference.ShowCurrentFilterMenu
   */
  global.CreateCurrentFilterMenu = function (btn) {
    if (!!Filters.menuItems) {
      Filters.contextMenuElementSelector = btn.selector;
      Filters.createReferenceMenu(btn.selector, Filters.menuItems);
    }
  };
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
   * Устанавливает выделенности кнопки "Текущий фильтр".
   * @since 5.0.0.4200
   * @function Core.toolBars.reference.SetCurrentFilterState
   */
  global.SetCurrentFilterState = function () {
    if (!!Filters.contextMenuElementSelector) {
      if (Core.grid.reference.state.CurrentFilter.Expression == '') {
        $(Filters.contextMenuElementSelector).removeClass('selected')
      } else {
        $(Filters.contextMenuElementSelector).addClass('selected')
      };
    };
  };
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
   * Callback срабатываемый после изменения текущего периода.
   * @since 5.0.0.4200
   * @function Core.toolBars.reference.PeriodSetCallback
   * @param {object} dialog - диалог установки фильтра по текущему периоду.
   */
  global.PeriodSetCallback = function (dialog) {
    Core.grid.reference.reloadData();
    if (Core.grid.reference.updateFooter) {
      Core.grid.reference.updateFooter();
    }
    // Изменяем заголовок страницы.
    appendCurrentPeriodInPageTitle();

    if (dialog) dialog.close()
  };

  /**
   * Добавление интервала дат текущего периода в заголовок страниц.
   *
   * @function appendCurrentPeriodInPageTitle
   * @return {Deferred<string>} Обновленный заголовок страницы.
   * @see https://api.jquery.com/category/deferred-object/
   */
  function appendCurrentPeriodInPageTitle() {
    var jObjectName = $(".card-header__label");
    var refCaption = jObjectName.data('pluraltitle');
    var def = $.Deferred();

    var isEnabled = WA.CR.toolBar.buttons['ToggleCurrentPeriod'].isSelected();
    if (isEnabled) {
      WA.SRV.call('/Session.asmx/GetCurrentPeriod').done(function (period) {
        var serverBegin = period.Period.AsString[0];
        var serverEnd = period.Period.AsString[1];
        if (!serverBegin || !serverEnd) {
          def.resolve(refCaption);
        } else {
          def.resolve(refCaption + ', ' + serverBegin + ' - ' + serverEnd);
        }
      });
    } else {
      def.resolve(refCaption);
    }

    def.always(function (caption) {
      document.title = caption;
      jObjectName.text(caption);
    });
  };
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
   * Нужно ли дизэйблить смену текущего периода.
   * @since 5.4.0.1012
   * @function Core.toolBars.reference.needDisableChangeCurrentPeriod
   */
  global.needDisableChangeCurrentPeriod = function () {
    // Дизэйблим кнопку "Изменить период" при вызове справчоника в модальном диалоге потому, что так в билдере.
    //Support ORPB	В общем это легаси код, почему так сказать сложно.
    //Support ORPB	Возможно смысл тут в том, что мы если выбираем, то выбираем куда-то и смысла менять текущий период тут нет.
    return global.getReferenceContext().toLowerCase().indexOf('modal') !== -1;
  };
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
   * Опеределяет текущий контекст.
   * @since 5.4.0.1012
   * @function Core.toolBars.reference.getReferenceContext
   */
  global.getReferenceContext = function () {
    return Core.grid.getPlacementContext();
  };
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
  * Экспорт записей в CSV.
  * @since 5.0.0.4200
  * @function Core.toolBars.reference.ExportRecords
  */
  global.ExportRecords = function (btn) {
    WA.SRV.call('/Reference.asmx/ExportRecordsToExcel', {
      Params: $.toJSON(Core.grid.reference.state)
    }).done(function (guid) {
      if (WA.agent.isAvailable()) {
        WA.agent.isPluginAvailable('DocumentPlugin').done((isPluginAvailable) => {
          if (isPluginAvailable && WA.agent.isSessionInitialized()) {
              RequestToken(TOKEN_OPERATION.DOWNLOAD_DOCUMENT_BODY, function (token) {
              var requestParams = {
                id: guid,
                Token: token,
                Repository: "FileSystem",
                DownloadTool: "Handler",
                loc: document.location.host,
                name: WA.CR.ReferenceCode
              };
              WA.agent.transmitRequest('opendocument', 'DocumentPlugin', requestParams).fail((response) => {
                ShowError(response.message);
              });
            });
          } else {
            download();
          }
        }).fail(function () {
          download();
        });
      } else {
        download();
      }

      function download() {
        var url = new WA.URL('/download.ashx');
        url.setParam('accesstype', 'private');
        url.setParam('id', guid);
        url.setParam('name', WA.CR.ReferenceCode);
        url.open();
      }    
    });
  };


  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//


})(window.Core.toolBars.reference);